import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { IProject } from '@newroom-connect/library/interfaces';
import { AreaService, CacheRevalidationService, ProjectErrorHandlerService, ProjectService, SwUpdateService } from '@newroom-connect/library/services';
import { Observable, map, catchError, of, switchMap } from 'rxjs';

export const ProjectResolver: ResolveFn<IProject | null> = (route: ActivatedRouteSnapshot): Observable<IProject | null> => {
  const projectService = inject(ProjectService);
  const areaService = inject(AreaService);
  const swUpdateService = inject(SwUpdateService);
  const cacheRevalidationService = inject(CacheRevalidationService);
  const projectErrorHandlerService = inject(ProjectErrorHandlerService);

  const projectSlug = route.paramMap.get('projectSlug');

  if (!projectSlug) {
    return of(null);
  }

  return projectService.getProjectBySlug(projectSlug).pipe(
    switchMap((project) => {
      projectService.setCurrentProject(project);

      // Initialize service worker update and cache handling.
      swUpdateService.initialize(project.id);

      return areaService.initializeCache(project.id).pipe(
        switchMap(() => cacheRevalidationService.revalidateAll(project.id)),
        map(() => project),
        catchError(() => of(project))
      );
    }),
    catchError(() => {
      projectErrorHandlerService.handleGetError();
      return of(null);
    })
  );
};
